// extracted by mini-css-extract-plugin
export default {"myWork":"MyWork_myWork__2fFYy"};